import React, {
  createContext, useReducer, FC, Dispatch,
} from 'react';
import CartReducer, { StateInterface } from '../Reducers/cartReducer';

const initialState = {
  id: '',
  userId: '',
  cartItems: [],
};

interface ContextProps {
  state: StateInterface;
  dispatch: Dispatch<any>;
}

export const CartContext = createContext<ContextProps>({
  state: initialState,
  dispatch: () => null,
});

const CartProvider: FC = ({
  children,
}) => {
  const [state, dispatch] = useReducer(CartReducer, initialState);

  return (
    <CartContext.Provider value={{
      state, dispatch,
    }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
